<template>
  <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 20px">
    <h4 style="margin-bottom: 0;">Quản lý hóa đơn thuế</h4>
    <div class="">
      <el-button type="primary" class="text-white" style="border: none" @click="exportExcel">
        <i class="el-icon-download text-white"></i> <span>Export</span>
      </el-button>
      <el-button type="info" class="text-white" style="background: #1BC5BD !important; border: none" @click="isImport = true">
        <i class="el-icon-plus text-white"></i><span>Import</span>
      </el-button>
      <el-button style="background-color: #5D04B0; color: white" @click="showReissueDialog = true">Phát hành lại hóa đơn</el-button>
    </div>
    <el-dialog
        v-if="isImport"
        title="Import hóa đơn thuế"
        :visible.sync="isImport"
        :width="isError ? '60%' : '50%'"
        :before-close="handleCloseDialog"
    >
      <hr style="margin-top: -20px"/>
      <ImportTaxInvoice @closeDialog="isImport = false" @isError="isError = true" @getListTaxInvoice="getListTaxInvoice"/>
    </el-dialog>
    <el-dialog :visible.sync="showReissueDialog" width="900px" :title="'Phát hành lại hóa đơn thuế'" @open="resetReissueDialog">
      <div style="margin-bottom: 12px">
        <div style="font-weight:600; margin-bottom:8px">Chọn mã hóa đơn</div>
        <div class="reissue-search">
          <el-input
            v-model="searchKeyword"
            clearable
            placeholder="Chọn mã hóa đơn phát hành lại"
            suffix-icon="el-icon-search"
            @input="onSearchInput"
            @focus="showSearchDropdown = true"
            @blur="onSearchBlur"
          />
          <div
            v-show="showSearchDropdown && (schoolLoading || searchKeyword)"
            class="reissue-search-dropdown"
            @mousedown.prevent
          >
            <div v-loading="schoolLoading" style="min-height: 40px">
              <div
                v-for="item in searchResults"
                :key="item.id"
                class="reissue-search-item"
                @click="toggleReissueItemClick(item)"
              >
                <el-checkbox
                  :value="isReissueSelected(item)"
                  @click.native.prevent
                >
                  {{ item.codeInvoice }}
                </el-checkbox>
              </div>
              <div
                v-if="!schoolLoading && searchKeyword && !searchResults.length"
                class="reissue-search-empty"
              >
                Không tìm thấy hóa đơn
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <table class="table table-bordered" style="width:100%">
          <thead>
          <tr style="background:#F8F8F8">
            <th style="width:60px">STT</th>
            <th>MÃ HÓA ĐƠN</th>
            <th>KẾT QUẢ PHÁT HÀNH {{ reResult ? 'LẠI' : '' }}</th>
            <th v-if="!reResult" style="width:120px; text-align: center">HÀNH ĐỘNG</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, idx) in paginatedReIssue" :key="item.id" style="border-top:0">
            <td>{{ reIssueDisplayFrom + idx }}</td>
            <td style="color:#0066FF; font-weight:600">{{ item.codeInvoice }}</td>
            <td>
              <span
                v-if="item.reissueResult && reResult"
                class="reissue-result-badge"
                :class="item.reissueStatus === DA_PHAT_HANH ? 'is-success' : 'is-failed'"
              >
                <span class="reissue-result-dot"></span>
                {{ item.reissueResult }}
              </span>
            </td>
            <td v-if="!reResult" style="text-align:center"><button class="btn btn-icon btn-xs btn-outline-danger" @click="removeReissueItem(idx)"><i class="el-icon-delete"></i></button></td>
          </tr>
          <tr v-if="displayedReIssue.length === 0">
            <td :colspan="reResult ? 3 : 4" style="text-align:center">Chưa có hóa đơn</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="displayedReIssue.length > 0"
        class="edu-paginate mx-auto text-center mt-10 mb-5"
        style="display: flex; justify-content: center; align-items: center; height: 50px"
      >
        <paginate
          v-model="reIssuePage"
          :page-count="reIssueLastPage"
          :page-range="3"
          :margin-pages="1"
          :click-handler="changeReissuePage"
          :prev-text="'Trước'"
          :next-text="'Sau'"
          :container-class="'pagination b-pagination'"
          :pageLinkClass="'page-link'"
          :next-link-class="'next-link-item'"
          :prev-link-class="'prev-link-item'"
          :prev-class="'page-link'"
          :next-class="'page-link'"
          :page-class="'page-item'"
        ></paginate>
      </div>
      <div v-if="displayedReIssue.length > 0" class="w-100" style="display: flex;justify-content: flex-end; margin-top: -50px">
        Tổng số bản ghi: <span style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{ displayedReIssue.length }}</span>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="showReissueDialog = false">HỦY</el-button>
        <el-button type="primary" style="color: white" :loading="reissueSubmitting" @click="handleExportReissue">XUẤT HÓA ĐƠN</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {exportExcel} from "@/core/filters";
import {EXPORT_TAX_INVOICE, GET_LIST_TAX_INVOICE, ISSUE_INVOICES} from "@/core/services/store/tax-invoice/tax-invoice.module";
import {TaxInvoiceModel} from "../model/TaxInvoiceModel";
import ImportTaxInvoice from "./ImportTaxInvoice.vue";
import {DA_PHAT_HANH, THAT_BAI} from "@/common/define";

export default {
  components: {ImportTaxInvoice},
  data() {
    return {
      DA_PHAT_HANH,
      THAT_BAI,
      is_export_excel: false,
      isImport: false,
      isError: false,
      showReissueDialog: false,
      searchKeyword: '',
      searchResults: [],
      selectedReIssue: [],
      reissueResults: [],
      reIssuePage: 1,
      reIssueLastPage: 1,
      showSearchDropdown: false,
      schoolLoading: false,
      searchTimer: null,
      reissueSubmitting: false,
      reResult: false
    }
  },
  computed: {
    displayedReIssue() {
      return this.reResult ? this.reissueResults : this.selectedReIssue
    },
    paginatedReIssue() {
      const start = (this.reIssuePage - 1) * 5
      return this.displayedReIssue.slice(start, start + 5)
    },
    reIssueDisplayFrom() {
      if (!this.displayedReIssue.length) return 0
      return (this.reIssuePage - 1) * 5 + 1
    },
  },
  methods: {
    handleCloseDialog() {
      this.isImport = false
    },
    getListTaxInvoice() {
      this.$emit('getListTaxInvoice')
    },
    exportExcel() {
      this.is_export_excel = true
      const HEADER_ROW_EXPORT_TAX_INVOICE = [
        {
          key: 'id',
          value: 'Mã hóa đơn thuế',
        },
        {
          key: 'codeInvoice',
          value: 'Mã hóa đơn',
        },
        {
          key: 'releaseCode',
          value: 'Mã phát hành',
        },
        {
          key: 'typeString',
          value: 'Phân loại',
        },
        {
          key: 'statusString',
          value: 'Trạng thái',
        },
        {
          key: 'name',
          value: 'Tên khách hàng',
        },
        {
          key: 'phone',
          value: 'Số điện thoại',
        },
        {
          key: 'amount',
          value: 'Số tiền',
        },
        {
          key: 'createdAt',
          value: 'Thời gian tạo',
        },
        {
          key: 'releaseDate',
          value: 'Ngày phát hành',
        },
        {
          key: 'address',
          value: 'Địa chỉ',
        },
        {
          key: 'centerName',
          value: 'Trung tâm',
        },
        {
          key: 'code_gt',
          value: 'Mã giới thiệu',
        },
        {
          key: 'leaderId',
          value: 'Mã cấp trên',
        },
      ]
      const payload = { ...this.$route.query }
      this.$store.dispatch(EXPORT_TAX_INVOICE, payload).then((res) => {
        this.is_export_excel = false
        if (res.error) {
          this.$bvToast.toast(res.data.message, {
            title: 'Export excel',
            variant: 'danger',
            solid: true
          });
        } else {
          const data = res.data.map(item => new TaxInvoiceModel(item))
          exportExcel(HEADER_ROW_EXPORT_TAX_INVOICE, data, "Danh sách hoá đơn thuế.xlsx", false)
        }
      });
    },

    resetReissueDialog() {
      this.searchKeyword = ''
      this.searchResults = []
      this.selectedReIssue = []
      this.reissueResults = []
      this.reIssuePage = 1
      this.reIssueLastPage = 1
      this.showSearchDropdown = false
      this.reResult = false
    },

    onSearchInput() {
      if (this.reResult) {
        this.reResult = false
        this.reissueResults = []
        this.reIssuePage = 1
        this.reIssueLastPage = 1
      }
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.searchTaxInvoice(this.searchKeyword)
      }, 300)
    },

    onSearchBlur() {
      setTimeout(() => {
        this.showSearchDropdown = false
      }, 200)
    },

    searchTaxInvoice(keyword) {
      const amountId = String(keyword || '').trim()
      if (!amountId) {
        this.searchResults = []
        return
      }
      this.schoolLoading = true
      this.showSearchDropdown = true
      const payload = {
        page: 1,
        amount_id: amountId,
        status: [5]
      }
      this.$store.dispatch(GET_LIST_TAX_INVOICE, payload).then((res) => {
        if (!res.error && res.data?.data) {
          this.searchResults = res.data.data.map(item => new TaxInvoiceModel(item))
        } else {
          this.searchResults = []
        }
      }).catch(() => {
        this.searchResults = []
      }).finally(() => {
        this.schoolLoading = false
      })
    },

    isReissueSelected(item) {
      return this.selectedReIssue.some(selected => selected.id === item.id)
    },

    toggleReissueItemClick(item) {
      this.toggleReissueItem(item, !this.isReissueSelected(item))
    },

    toggleReissueItem(item, checked) {
      const idx = this.selectedReIssue.findIndex(selected => selected.id === item.id)
      if (checked && idx === -1) {
        this.selectedReIssue.push({
          ...item,
          reissueStatus: THAT_BAI,
          reissueResult: 'Thất bại',
          reissueReason: '',
        })
        this.onSelectedReissueChange()
      } else if (!checked && idx !== -1) {
        this.selectedReIssue.splice(idx, 1)
        this.onSelectedReissueChange()
      }
    },

    onSelectedReissueChange() {
      this.reIssueLastPage = Math.max(1, Math.ceil(this.selectedReIssue.length / 5))
      if (this.reIssuePage > this.reIssueLastPage) this.reIssuePage = this.reIssueLastPage
    },

    changeReissuePage(page) {
      this.reIssuePage = page
    },

    removeReissueItem(idx) {
      const actualIdx = (this.reIssuePage - 1) * 5 + idx
      this.selectedReIssue.splice(actualIdx, 1)
      this.onSelectedReissueChange()
    },

    handleExportReissue() {
      if (!this.selectedReIssue.length) {
        this.$message.warning('Chưa chọn mã hóa đơn để xuất')
        return
      }
      const amountIds = this.selectedReIssue.map(item => item.amountId)
      this.reissueSubmitting = true
      this.$store.dispatch(ISSUE_INVOICES, {amount_ids: amountIds}).then((res) => {
        if (res.error) {
          this.$message.error(res.data?.message || 'Xuất hóa đơn thất bại')
          return
        }
        const results = res.data? res.data.results : []
        this.applyReissueResults(results)
        this.reResult = true
        this.getListTaxInvoice()
      }).catch(() => {
        this.$message.error('Xuất hóa đơn thất bại')
      }).finally(() => {
        this.reissueSubmitting = false
      })
    },

    applyReissueResults(results) {
      this.reissueResults = results.map(result => {
        const isSuccess = result.status === DA_PHAT_HANH
        return {
          id: result.id,
          amountId: result.amount_id,
          codeInvoice: result.amount_id,
          reissueStatus: result.status,
          reissueResult: isSuccess ? 'Thành công' : 'Thất bại',
          reissueReason: result.status === THAT_BAI ? (result.message_error || '') : '',
        }
      })
      this.selectedReIssue = []
      this.searchKeyword = ''
      this.searchResults = []
      this.showSearchDropdown = false
      this.reIssuePage = 1
      this.reIssueLastPage = Math.max(1, Math.ceil(this.reissueResults.length / 5))

      const successCount = results.filter(item => item.status === DA_PHAT_HANH).length
      const failCount = results.filter(item => item.status === THAT_BAI).length

      if (failCount === 0) {
        this.$message.success(`Xuất hóa đơn thành công ${successCount}/${results.length}`)
      } else {
        this.$message.warning(`Hoàn tất: ${successCount} thành công, ${failCount} thất bại`)
      }
    },
  },
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
    }
  },
}
</script>
<style>
.multiselect {
  width: 100% !important;
}

#select-customer {
  width: 50%;
}

.tvv {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 150px;
  align-content: center;
}

.custom-header {
  padding: 1rem 2.25rem;
}
.badge-pink {
  color: white;
  background-color: #BB2CFF;
}

.reissue-search {
  position: relative;
}

.reissue-search-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 2001;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.reissue-search-item {
  padding: 8px 12px;
  cursor: pointer;
}

.reissue-search-item:hover {
  background: #f5f7fa;
}

.reissue-search-empty {
  padding: 12px;
  text-align: center;
  color: #909399;
}

.reissue-result-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border: 1px solid;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.reissue-result-badge.is-success {
  color: #0f8a46;
  background: #effbf4;
  border-color: #cef3dc;
}

.reissue-result-badge.is-failed {
  color: #e53935;
  background: #fff2f1;
  border-color: #ffd6d2;
}

.reissue-result-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
</style>
